//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UsuarioIHM from '@/api/promotores/usuarios/ihm.api'

export default {
  data() {
    return {
      per_page_options: [10, 20, 30, 40, 50, 100],
      data: [],
      columns: [
        {
          name: "nombre",
          label: "Nombre",
          field: "nombre",
          align: "left",
          classes: "bg-grey-2 ellipsis",
          style: "width: 350px",
          headerClasses: "bg-primary text-white",
        },
				{ name: 'correo', field: 'correo', label: 'Email', align: 'left' },
				{ name: 'celular', field: 'celular', label: 'Celular', align: 'left' },
				{ name: 'desarrollo', field: 'desarrollo', label: 'Desarrollo', sortable: true, align: 'left' },
				{ name: 'comentarios', field: 'comentarios', label: 'Comentarios', align: 'left' },
				{ name: 'status', field: 'status', label: 'Status', sortable: true, align: 'left' },
				{ name: 'created_at', field: 'created_at', label: 'Creado', sortable: true, align: 'left' },
      ],
      loading: false,
      status: [
        { value: 'en proceso', label: 'En Proceso' },
        { value: 'autorizado', label: 'Autorizado' },
        { value: 'cancelado', label: 'Cancelado' },
      ],
    }
  },

  mounted() {
    this.loadProspectos()
  },

  methods: {
    async loadProspectos() {
      try {
        this.loading = true
        this.data = await UsuarioIHM.all(this.$route.params.promotor)
      } finally {
        this.loading = false
      }
    },
    async updateStatus(prospecto) {
      try {
        this.loading = true
        await UsuarioIHM.update(this.$route.params.promotor, prospecto._id, {
          status: prospecto.status
        })
        this.loadProspectos()
      } finally {
        this.loading = false
      }
    }
  }
}
